import { nToPx, themeVars } from '@tundr/theme';
import { globalStyle, style } from '@vanilla-extract/css';

globalStyle('.checkable-select .multiselect__option', {
  backgroundColor: themeVars.colors.neutrals.white,
  padding: 0,
  minHeight: 30,
  height: 45,
  color: themeVars.colors.neutrals.black100,
  position: 'relative',
});

globalStyle('.checkable-select .multiselect__option:hover', {
  backgroundColor: themeVars.colors.neutrals.grey30,
  color: themeVars.colors.neutrals.black100,
});

globalStyle('.checkable-select .multiselect__option--highlight', {
  backgroundColor: themeVars.colors.neutrals.grey30,
  color: themeVars.colors.neutrals.black100,
});

globalStyle('.checkable-select .multiselect__option--selected', {
  backgroundColor: themeVars.colors.neutrals.white,
  color: themeVars.colors.neutrals.black100,
  fontWeight: themeVars.font.weight.bold,
});

globalStyle('.checkable-select .multiselect__option--selected:hover', {
  backgroundColor: themeVars.colors.neutrals.grey30,
  color: themeVars.colors.neutrals.black100,
  fontWeight: themeVars.font.weight.bold,
});

globalStyle('.checkable-select .multiselect__option *', {
  color: themeVars.colors.neutrals.black100,
});

globalStyle('.checkable-select .multiselect__option:hover *', {
  color: themeVars.colors.neutrals.black100,
});

globalStyle('.checkable-select .multiselect__option--highlight *', {
  color: themeVars.colors.neutrals.black100,
});

globalStyle('.checkable-select .multiselect__option--selected *', {
  color: themeVars.colors.neutrals.black100,
  fontWeight: themeVars.font.weight.bold,
});

globalStyle('.checkable-select .multiselect__option--selected:hover *', {
  color: themeVars.colors.neutrals.black100,
  fontWeight: themeVars.font.weight.bold,
});

globalStyle('.checkable-select .multiselect__single', {
  color: themeVars.colors.neutrals.black100,
  fontWeight: themeVars.font.weight.bold,
});

globalStyle('.checkable-select .multiselect__tag', {
  backgroundColor: themeVars.colors.neutrals.grey30,
  color: themeVars.colors.neutrals.black100,
  fontWeight: themeVars.font.weight.bold,
});

globalStyle('.checkable-select .multiselect__tag *', {
  color: themeVars.colors.neutrals.black100,
  fontWeight: themeVars.font.weight.bold,
});

// workaround to fix click on disabled options
globalStyle(
  '.checkable-select .multiselect__option:has(.checkable-option-disabled)',
  {
    pointerEvents: 'none',
  },
);
globalStyle('.checkable-select .multiselect__option.option-disabled', {
  pointerEvents: 'none',
});

export const checkableOptionClass = style({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minHeight: '100%',
  gap: themeVars.space.x2,
  padding: nToPx(0, themeVars.space.x3),
  cursor: 'pointer',
  backgroundColor: 'transparent',
  position: 'relative',

  ':hover': {
    backgroundColor: 'transparent',
  },
});

export const checkableOptionDisabledMarkerClass = style({
  // This class is used as a marker for the CSS :has() selector
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
});

export const checkableOptionCheckboxClass = style({
  flexShrink: 0,
});

export const checkableOptionLabelClass = style({
  flex: 1,
  fontSize: themeVars.font.size.textMd,
  color: themeVars.colors.neutrals.black100,
  fontWeight: themeVars.font.weight.regular,
});
